import { getRolesList,getAllModules } from "../../api/list";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RoleListState {
  RoleList: any[];
  ModuleList: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState:RoleListState = {
  RoleList: [],
  ModuleList: [],
  isLoading: false,
  error: null,
};

export const FetchRoleListAPI = createAsyncThunk(
  "RoleList/fetchRoleList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getRolesList(params);
      const state: any = getState();
      const previousRoleList = state.RoleList?.RoleList || []; 
      if ([1, undefined].includes(res?.result?.page)) {
  
        dispatch(getrole(res?.result?.data || []));
      } else {
     
        dispatch(getrole([
          ...previousRoleList , 
          ...(res?.result?.data || []), 
        ]));
      }
      
      return res;
    } catch (error) {
      throw new Error('Error fetching role list');
    }
  }
);


export const FetchModuleListAPI = createAsyncThunk(
  "ModuleList/fetchModuleList",
  async (params: any, { dispatch, getState }) => {
    try {
      const res: any = await getAllModules(params);
      dispatch(getmodule(res?.result?.data || []));
      return {
        data: res?.result?.data || [],
      };
    } catch (error) {
      throw new Error('Error fetching module list');
    }
  }
);

const RoleListSlice = createSlice({
  name: 'RoleList',
  initialState,
  reducers: {
    getrole(state, action: PayloadAction<any[]>) {
      state.RoleList = action.payload;
    },
    updateRoleById(state, action: PayloadAction<{ id: string; data: Record<string, any> }>) {
      const { id, data } = action.payload;
      const index = state.RoleList.findIndex((role) => role.id === id);
      if (index !== -1) {
        state.RoleList[index] = { ...state.RoleList[index], ...data };
      }
    },
    getmodule(state, action: PayloadAction<any[]>) {
      state.ModuleList = action.payload;
    },
  }
});

export default RoleListSlice.reducer;
export const { getrole,getmodule,updateRoleById} = RoleListSlice.actions;
